export class TabulationTotalsOptions {
  constructor(
    public showRowSubtotals: boolean = false,
    public showRowTotals: boolean = false,
    public showColumnSubtotals: boolean = false,
    public showColumnTotals: boolean = false
  ) {}
  // Explicitly type keys so we can dynamically loop over the properties
  [key: string]: TabulationTotalsOptions[keyof TabulationTotalsOptions];
}
